var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpIconBlack({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.573 16.7732C19.2707 17.0756 18.7805 17.0756 18.4782 16.7732L11.7998 10.0949L5.12144 16.7732C4.81909 17.0756 4.3289 17.0756 4.02656 16.7732C3.72422 16.4709 3.72422 15.9807 4.02656 15.6784L11.2524 8.45256C11.5547 8.15022 12.0449 8.15022 12.3472 8.45256L19.573 15.6784C19.8754 15.9807 19.8754 16.4709 19.573 16.7732Z",
    fill: "#23242A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpIconBlack);
export default __webpack_public_path__ + "static/media/up-icon-black.c047a7db88e9cf9c35d44fbbd59762e8.svg";
export { ForwardRef as ReactComponent };